export const WEBSITE = {
    DOMAIN: 'www.clubsavellc.com'
}